export default {
  COMMUNITY: [
    'Administrative Assistant',
    'Boss',
    'Community Event / Festival',
    'Date Spot',
    'Most Colorful Character',
    'Non-Profit / Civic Support Organization',
    'Non-Profit / Civic Support Worker',
    'Place of Worship',
    'Place to be Seen',
    'Public Servant',
  ],
  'ARTS / ENTERTAINMENT': [
    'Art Gallery',
    'Day Trip',
    'Band / Musician',
    'Music Instruction',
    'Music Shop',
    'Performing Arts Group',
    'Performing Arts / Music Venue',
    'Photographer',
    'Museum',
    'Movie Theater',
    'Live Music Venue',
    'Festival',
  ],
  AUTO: [
    'Auto Repair Shop',
    'Mechanic',
  ],
  'BEAUTY / WELLNESS': [
    'Barber Shop',
    'Esthetician',
    'Hair Salon',
    'Hairstylist / Barber',
    'Massage Services',
    'Massage Therapist',
    'Nail Salon',
    'Spa',
    'Tanning Salon',
  ],
  'CHILDCARE / EDUCATION': [
    'Camp / Summer Program',
    'Childcare / Preschool',
    'College / University',
    'Private School',
    'Public School',
    'Teacher',
  ],
  'EMERGENCY SERVICES': [
    'Firefighter',
    'Law Enforcement Officer',
  ],
  DINING: [
    'Grocery Store',
    'Restaurant',
    'Wine Bar',
    'Happy Hour',
    'Sports Bar',
    'Kid Friendly Restaurant',
    'Bakery / Pastries',
    'Bar / Pub',
    'Steakhouse',
    'BBQ Restaurant',
    'Brewery',
    'Lunch Spot',
    'Coffee Shop',
    'Deli',
    'Bagels',
    'Family Restaurant',
    'Fine Dining',
    'Hamburger / Cheeseburger',
    'Food Truck',
    'Seafood',
    'Tacos',
    'Pasta',
    'Butcher',
    'Outdoor Dining',
    'Pizza',
    'Romantic Dining',
    'Sandwich / Sub',
    'Sushi',
    'Farmer\'s Market',
    'Wings',
    'Vegetarian Restaurant',
  ],
  'HOME / GARDEN': [
    'Carpet Care',
    'Dry Cleaners',
    'Furniture Store',
    'Interior Design Services',
    'Lawn / Garden Equipment',
    'Maid Service',
    'Moving Service',
    'Mowing / Landscape Company',
    'Pest Control',
    'Picture Framer',
    'Plant Center',
    'Tree Care',
  ],
  'HEALTH / MEDICAL': [
    'Alternative Medicine',
    'Chiropractor',
    'Dentist',
    'Eye Doctor',
    'General Practitioner',
    'Nurse',
    'Obstetrician / Gynecologist / Midwife',
    'Orthodontist',
    'Pediatrician',
    'Pharmacy',
    'Plastic Surgeon',
    'Psychiatrist',
    'Psychologist / Counselor',
    'Urgent Care Facility',
    'Dermatology',
  ],
  HOSPITALITY: [
    'Hotel / Resort',
    'Tourist Destination',
  ],
  OCCASIONS: [
    'Cake / Cupcakes',
    'Catering Company',
    'DJ',
    'Event Photography',
    'Event Planner',
    'Event Rentals',
    'Event Venue',
    'Florist',
    'Limo / Car Service',
  ],
  PETS: [
    'Animal Adoption Organization',
    'Animal Rescue Organization',
    'Pet Kennel',
    'Pet Services',
    'Pet Store',
    'Dog Park',
    'Veterinarian',
    'Veterinary Practice',
    'Dog Groomer',
  ],
  'PROFESSIONAL SERVICES': [
    'Accountant',
    'Attorney',
    'Bank',
    'Banker',
    'Financial Advisor',
    'Insurance Agent',
    'Mortgage Broker',
    'Mortgage Brokerage',
    'Title Company',
  ],
  'RECREATION / FITNESS': [
    'Dance Instructor / Choreographer',
    'Dance Studio',
    'Fitness Center / Gym',
    'Golf Course',
    'Personal Trainer',
    'Recreation Facility',
    'Yoga / Pilates Instructor',
    'Yoga / Pilates Studio',
  ],
  'REAL ESTATE / CONSTRUCTION / HOME IMPROVEMENT': [
    'Architect',
    'Builder / Construction Company',
    'Carpentry Company',
    'Commercial Real Estate Brokerage',
    'Commercial Realtor',
    'Countertops',
    'Electrician',
    'Handyman / Home Services',
    'Hardware Store',
    'HVAC Company',
    'Painting Company',
    'Plumbing Company',
    'Remodeling Company',
    'Residential Real Estate Brokerage',
    'Residential Realtor',
    'Real Estate Team',
    'Roofing Company',
  ],
  SHOPPING: [
    'Consignment',
    'Grocery Store',
    'Jewelry',
    'Specialty Store',
    'Antiques',
  ],
  MISCELLANEOUS: [
    'Customer Service',
    'Funeral Home',
    'Senior Living Facility',
    'Travel Agency',
    'Retirement Community',
    'Car Wash',
    'Boutique',
    'Hardware Store',
  ],
};
